import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ToastContainer, toast } from "react-toastify";
import { Helmet } from "react-helmet";
import SEOHead from "../../../components/SEOHead";
import ScrollToTop from "../../../components/whatsapp connect";
import LoaderMain from "../../../layout/header/loader_sub";
import { backend, producturl } from "../../../../path";
import ProductCard from "../../../components/ProductCard/ProductCard";

function DealsPage(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [deals, setDeals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  useEffect(() => {
    fetchDeals();
  }, [currentPage]);

  const fetchDeals = () => {
    setLoading(true);
    setError(null);

    fetch(backend + "getallspecialproduts", { method: "GET" })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then((res) => {
        setData(res);
        const list = res?.getDealOfTheDay || [];
        const startIndex = (currentPage - 1) * productsPerPage;
        const endIndex = startIndex + productsPerPage;
        setDeals(list.slice(startIndex, endIndex));
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const handleProductRoute = (slug) => {
    navigate(`/product/${slug}`);
  };

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }
    const formData = { status: 1, quantity: 1, product_id: id };
    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.status === 200) {
        toast.success("Item added to cart", { position: "top-right", autoClose: 3000 });
        props.setCartChange && props.setCartChange(!props.cartChange);
      } else if (response.status === 401) {
        toast.error("Item already exists in the cart", { position: "top-right", autoClose: 3000 });
      } else {
        toast.error("Something went wrong. Please try again later.", { position: "top-right", autoClose: 3000 });
      }
    } catch (e) {
      toast.error("Something went wrong. Please try again later.", { position: "top-right", autoClose: 3000 });
    }
  };

  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }
    const formData = { status: 0, product_id: id };
    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });
      if (response.status === 200) {
        toast.success("Item added to wishlist", { position: "top-right", autoClose: 3000 });
        props.setWishChange && props.setWishChange(!props.wishChange);
      } else if (response.status === 401) {
        toast.error("Item already exists in the wishlist", { position: "top-right", autoClose: 3000 });
      }
    } catch (e) {
      // silently ignore
    }
  };

  const dealsList = data?.getDealOfTheDay || [];
  const totalDeals = dealsList.length;

  return (
    <>
      <ToastContainer />
      <SEOHead
        title="Today's Best Deals & Offers on Kerala Products | KeralaSpecial.in"
        description="Exclusive limited-time deals on authentic Kerala spices, Kasavu Mundu, handloom sarees, and traditional Ayurvedic wellness products with fast worldwide shipping."
        keywords="Today's Deals Kerala, Kerala Products Offers, Cheap Kerala Spices, Discounted Kasavu Mundu, Kerala Handicrafts Deals"
        canonical="https://keralaspecialtours.com/deals"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://keralaspecialtours.com/" },
            { "@type": "ListItem", "position": 2, "name": "Today's Deals", "item": "https://keralaspecialtours.com/deals" }
          ]
        }}
      />
      <main className="bg-white min-h-screen">
        {loading && <LoaderMain />}

        <div className="mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl pt-36 lg:pt-36 md:pt-28 pt-24 pb-16">
          {/* Visual Hero Banner */}
          <div 
            className="relative w-full overflow-hidden text-left mb-10 rounded-3xl flex flex-col md:flex-row items-stretch"
            style={{
              background: "linear-gradient(135deg, #123524 0%, #0d261a 100%)",
              border: "1px solid rgba(197, 168, 128, 0.15)"
            }}
          >
            {/* Ambient light patterns */}
            <div className="absolute inset-0 pointer-events-none opacity-10 bg-[radial-gradient(#C5A880_1px,transparent_1px)] [background-size:16px_16px]" />
            <div className="absolute -left-24 -bottom-24 w-96 h-96 rounded-full bg-[#123524]/40 filter blur-3xl pointer-events-none" />
            
            {/* Left Content (Text) */}
            <div className="w-full md:w-[60%] relative z-10 flex flex-col justify-center py-12 px-6 sm:px-12 md:px-16 lg:py-20">
              {/* Floating breadcrumbs */}
              <div className="inline-flex self-start items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-xs font-medium text-white/80 mb-6 font-jost">
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
                <span className="text-[#C5A880]/60">/</span>
                <span className="text-[#C5A880]">Today's Deals</span>
              </div>
              
              <span className="block text-[#C5A880] font-jost text-xs sm:text-sm font-semibold tracking-widest uppercase mb-2">
                Limited Time Offers
              </span>
              <h1 className="text-white font-playfair text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight mb-4">
                Today's Deals
              </h1>
              <div className="h-0.5 w-20 bg-[#C5A880] mb-6"></div>
              <p className="text-white/80 font-jost text-sm sm:text-base leading-relaxed max-w-xl text-justify mb-0">
                Grab today's premium handcrafted treasures, heritage looms, and organic single-origin spices at exclusive, limited-time prices. Sustaining direct-from-source values.
              </p>
            </div>

            {/* Right Column – Full-Height Filled Image Showcase */}
            <div 
              className="hidden md:block md:w-[40%] relative overflow-hidden select-none flex-shrink-0"
              style={{
                clipPath: "polygon(12% 0, 100% 0, 100% 100%, 0% 100%)"
              }}
            >
              <img 
                src="/storage/category/deals_plain.png" 
                alt="Today's Deals" 
                className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
              />
              {/* Inner ambient glow/overlay */}
              <div className="absolute inset-0 bg-[#123524]/10 pointer-events-none" />
              {/* Seamless gradient fade-out to matching theme background */}
              <div 
                className="absolute inset-y-0 left-0 w-24 pointer-events-none bg-gradient-to-r from-[#123524] to-transparent"
              />
            </div>
          </div>

          {/* Sub Toolbar showing deals count */}
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white border border-[#F2ECE1] rounded-2xl p-4 mb-8 gap-4 shadow-[0_4px_20px_rgba(45,31,24,0.01)] text-left">
            <div className="flex items-center gap-2">
              <span className="font-jost text-sm text-[#2D1F18]/60">Showing</span>
              <span className="font-jost font-semibold text-sm text-[#123524] bg-[#F2ECE1] px-3 py-1 rounded-full border border-[#C5A880]/15">
                {totalDeals} Exclusive Deals
              </span>
            </div>
            
            <div className="flex items-center gap-4">
              <span className="font-jost text-sm text-[#2D1F18]/40">Items on Page: {deals.length}</span>
            </div>
          </div>

          {error ? (
            <div className="bg-red-50 text-red-700 rounded-2xl p-6 text-center border border-red-100">
              <h3 className="font-playfair text-lg font-bold mb-2">We couldn't fetch the deals</h3>
              <p className="font-jost text-sm">{error.message}</p>
            </div>
          ) : totalDeals === 0 && !loading ? (
            <div className="bg-white border border-[#F2ECE1] rounded-3xl p-12 text-center shadow-sm max-w-xl mx-auto">
              <div className="text-4xl mb-4">🍂</div>
              <h2 className="font-playfair text-2xl font-bold text-[#2D1F18] mb-2">No Active Deals Right Now</h2>
              <p className="font-jost text-sm text-[#2D1F18]/60 leading-relaxed mb-6">
                Check back soon for freshly curated offers from our trusted sellers. You can continue exploring other categories in the meantime.
              </p>
              <button 
                onClick={() => navigate("/")}
                className="bg-[#123524] text-white font-jost font-medium px-6 py-2.5 rounded-xl border border-[#123524] hover:bg-[#C5A880] hover:border-[#C5A880] transition-all cursor-pointer shadow-md"
              >
                Explore Store
              </button>
            </div>
          ) : (
            <>
              {/* Product Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 text-left">
                {deals.map((item) => {
                  const salePrice = Number(item?.sale_price) || 0;
                  const mrp = Number(item?.mrp) || 0;
                  const discount = mrp && mrp > salePrice
                    ? Math.round(((mrp - salePrice) / mrp) * 100)
                    : 0;
                  const mockStock = ((item.product_id?.toString().charCodeAt(0) || 77) % 6) + 2;
                  const progressWidth = (mockStock / 8) * 100;

                  return (
                    <div 
                      key={item.product_id || item.product_slug}
                      className="group relative bg-[#FDFBF7] border border-[#C5A880]/15 rounded-3xl p-4 shadow-[0_4px_20px_rgba(45,31,24,0.02)] hover:shadow-[0_12px_35px_rgba(197,168,128,0.12)] hover:border-[#C5A880]/35 -translate-y-0 hover:-translate-y-1.5 transition-all duration-500 flex flex-col justify-between"
                    >
                      <div>
                        {/* Media Area */}
                        <div className="relative aspect-square w-full rounded-2xl overflow-hidden mb-4 select-none bg-white">
                          <img 
                            src={producturl + item.thumbnail} 
                            alt={item?.product_name} 
                            onClick={() => handleProductRoute(item.product_slug)}
                            className="w-full h-full object-contain p-2 cursor-pointer transition-transform duration-700 ease-out group-hover:scale-105"
                          />
                          
                          {/* Rich Scarcity Badges */}
                          {discount > 0 && (
                            <span className="absolute top-3 left-3 bg-[#db0f0f] text-white text-[10px] font-bold px-3 py-1 rounded-full shadow-md tracking-wider uppercase select-none animate-pulse">
                              -{discount}% OFF
                            </span>
                          )}

                          <button
                            onClick={() => handleAddToWishList(item.product_id)}
                            className="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/80 backdrop-blur-sm shadow border border-[#C5A880]/10 flex items-center justify-center text-[#2D1F18]/60 hover:text-[#db0f0f] hover:bg-white transition-all cursor-pointer"
                            aria-label="Add to wishlist"
                          >
                            <svg className="w-4.5 h-4.5 fill-current" viewBox="0 0 24 24">
                              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
                            </svg>
                          </button>
                        </div>

                        {/* Card Meta Content */}
                        <span className="block text-[#C5A880] text-[10px] font-semibold tracking-widest uppercase mb-1.5">
                          {item?.vendor_name || "Kerala Special"}
                        </span>
                        
                        <h3 
                          onClick={() => handleProductRoute(item.product_slug)}
                          className="font-playfair font-bold text-sm sm:text-base text-[#123524] mb-2 hover:text-[#C5A880] cursor-pointer line-clamp-2 transition-colors min-h-[40px] leading-tight"
                        >
                          {item?.product_name}
                        </h3>

                        {/* Star Rating Row */}
                        <div className="flex items-center gap-1.5 mb-3">
                          <div className="flex items-center">
                            {Array.from({ length: 5 }).map((_, idx) => (
                              <svg 
                                key={idx} 
                                className={`w-3.5 h-3.5 ${idx < Math.round(Number(item.average_stars) || 4.5) ? 'text-amber-500 fill-current' : 'text-gray-200 fill-current'}`} 
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
                              </svg>
                            ))}
                          </div>
                          <span className="text-[11px] font-jost text-[#2D1F18]/50">({item?.ratings_count || "45 reviews"})</span>
                        </div>

                        {/* Scarcity Stock Indicator Bar */}
                        <div className="mb-4">
                          <div className="flex justify-between items-center text-[10px] font-jost mb-1 select-none">
                            <span className="text-[#db0f0f] font-bold flex items-center gap-1">
                              <span className="w-1.5 h-1.5 rounded-full bg-[#db0f0f] animate-ping" />
                              Almost Sold Out
                            </span>
                            <span className="text-[#2D1F18]/70">Only <strong className="text-black">{mockStock}</strong> left!</span>
                          </div>
                          <div className="w-full h-1.5 bg-[#F2ECE1] rounded-full overflow-hidden">
                            <div 
                              className="h-full bg-gradient-to-r from-[#FF7E40] to-[#db0f0f] rounded-full transition-all duration-1000" 
                              style={{ width: `${progressWidth}%` }}
                            />
                          </div>
                        </div>
                      </div>

                      {/* Footer Actions */}
                      <div>
                        <div className="h-px bg-[#C5A880]/15 w-full mb-3" />
                        <div className="flex items-center justify-between gap-2">
                          <div className="flex flex-col text-left">
                            <span className="text-[9px] uppercase font-jost text-[#2D1F18]/40 leading-none">Deal Price</span>
                            <div className="flex items-baseline gap-1 mt-0.5">
                              <span className="font-poppins font-bold text-[#123524] text-base">₹{salePrice}</span>
                              {mrp > salePrice && (
                                <span className="font-poppins text-xs text-[#2D1F18]/40 line-through">₹{mrp}</span>
                              )}
                            </div>
                          </div>

                          <button
                            onClick={() => handleAddCart(item.product_id)}
                            className="bg-[#123524] hover:bg-[#C5A880] text-white font-jost text-xs font-semibold px-4 py-2 rounded-xl flex items-center gap-1.5 shadow-md active:scale-95 transition-all cursor-pointer border border-[#123524] hover:border-[#C5A880]"
                          >
                            <i className="fi-rs-shopping-cart" />
                            <span>Claim</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Pagination controls */}
              {totalDeals > productsPerPage && (
                <div className="flex items-center justify-center gap-3 mt-12 pb-10">
                  {/* Prev Button */}
                  <button
                    type="button"
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border font-jost text-sm font-semibold tracking-wide transition-all duration-300 ${currentPage === 1
                        ? "bg-[#F2ECE1]/40 text-gray-400 border-gray-200 cursor-not-allowed"
                        : "border-[#123524] text-[#123524] bg-white hover:bg-[#123524] hover:text-white shadow-sm hover:shadow"
                      }`}
                  >
                    <span>←</span>
                    <span>Previous</span>
                  </button>

                  {/* Current Page */}
                  <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-[#123524] text-white font-jost font-semibold text-sm shadow-md border border-[#123524]">
                    {currentPage}
                  </span>

                  {/* Next Button */}
                  <button
                    type="button"
                    onClick={() => setCurrentPage((prev) => prev + 1)}
                    disabled={deals.length < productsPerPage}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-xl border font-jost text-sm font-semibold tracking-wide transition-all duration-300 ${deals.length < productsPerPage
                        ? "bg-[#F2ECE1]/40 text-gray-400 border-gray-200 cursor-not-allowed"
                        : "border-[#123524] text-[#123524] bg-white hover:bg-[#123524] hover:text-white shadow-sm hover:shadow"
                      }`}
                  >
                    <span>Next</span>
                    <span>→</span>
                  </button>
                </div>
              )}
            </>
          )}
        </div>
        <ScrollToTop />
      </main>
    </>
  );
}

export default DealsPage;
